var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.30816 8.30592C3.50554 8.11004 3.7732 8 4.05229 8C4.33138 8 4.59904 8.11004 4.79641 8.30592L10.0064 13.4779L15.2163 8.30592C15.4148 8.11559 15.6807 8.01027 15.9566 8.01266C16.2326 8.01504 16.4966 8.12492 16.6917 8.31865C16.8869 8.51237 16.9976 8.77443 17 9.04839C17.0024 9.32235 16.8963 9.58628 16.7045 9.78334L10.7505 15.6941C10.5531 15.89 10.2854 16 10.0064 16C9.72727 16 9.4596 15.89 9.26223 15.6941L3.30816 9.78334C3.11085 9.5874 3 9.32169 3 9.04463C3 8.76757 3.11085 8.50186 3.30816 8.30592Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow-down.77053ea1df46b8eb1143e54c61b3dbaf.svg";
export { ForwardRef as ReactComponent };